import {
  PulseConfigurationKeys,
  PulseConfigurations,
  PULSE_FEATURE_NAME,
} from '@epicuro-next/constants/rule-engine/pulse-rules';
import {
  getValueFromConfigState,
  selectConfigurationsState,
} from '@epicuro-next/platform/configuration';
import { createSelector } from '@ngrx/store';

import { DocumentControlRuleType } from '../../models';

export const selectIsDocumentControlEnabled = createSelector(
  selectConfigurationsState,
  (config) => {
    return getValueFromConfigState<
      PulseConfigurationKeys.DocumentControlEnabled,
      PulseConfigurations
    >(
      config,
      PULSE_FEATURE_NAME,
      PulseConfigurationKeys.DocumentControlEnabled,
      false,
    );
  },
);

export const selectDocumentControlBlacklistRules = createSelector(
  selectConfigurationsState,
  (config) => {
    return getValueFromConfigState<
      PulseConfigurationKeys.DocumentControlCommercialListBlacklist,
      PulseConfigurations
    >(
      config,
      PULSE_FEATURE_NAME,
      PulseConfigurationKeys.DocumentControlCommercialListBlacklist,
      [],
    );
  },
);

export const selectAllowedDocumentControlRules = createSelector(
  selectDocumentControlBlacklistRules,
  (blackListRules) =>
    Object.values(DocumentControlRuleType).filter(
      (rule) => !blackListRules.includes(rule),
    ),
);
